import { toHex } from "./hex";

import type { Branded } from "../typing-utils/branded_types";

type UUIDString = Branded<string, "UUID">;

// crypto.randomUUID needs Safari 15.4+ (we support 11.1), hence the fallbacks
export function randomUUID(): UUIDString {
  if (globalThis.crypto?.randomUUID)
    return globalThis.crypto.randomUUID() as UUIDString;

  const bytes = new Uint8Array(16);
  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(bytes);
  } else {
    // not cryptographically secure, but none of our uses need it to be
    for (let i = 0; i < bytes.length; i++)
      bytes[i] = Math.floor(Math.random() * 256);
  }

  // RFC 4122 version and variant bits
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = toHex(bytes);
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}` as UUIDString;
}
